import { render, staticRenderFns } from "./FindChat.vue?vue&type=template&id=20ea3bfa&scoped=true&"
import script from "./FindChat.vue?vue&type=script&lang=js&"
export * from "./FindChat.vue?vue&type=script&lang=js&"
import style0 from "./FindChat.vue?vue&type=style&index=0&id=20ea3bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea3bfa",
  null
  
)

export default component.exports